import React from 'react';
import { motion } from 'framer-motion';
export function CienciaSection() {
  return <section id="la-ciencia" className="relative min-h-[auto] sm:min-h-[80vh] flex items-center px-4 sm:px-[5%] py-16 sm:py-20 bg-cover bg-center" style={{
    backgroundImage: "url('https://cdn.shopify.com/s/files/1/0981/0781/8286/files/El_Hero_Visual_Fondo_de_red_neuronal.png?v=1775420937')"
  }} data-id="element-11">
      {/* Overlay */}
      <div className="absolute inset-0" style={{
      background: 'linear-gradient(180deg, #0A0A0B 5%, rgba(10,10,11,0.6) 50%, #0A0A0B 95%)',
      zIndex: 1
    }} data-id="element-12" />
      <div className="absolute inset-0 hidden lg:block" style={{
      background: 'linear-gradient(90deg, #0A0A0B 15%, transparent 60%, #0A0A0B 95%)',
      zIndex: 1
    }} data-id="element-13" />

      {/* Content */}
      <div className="relative max-w-[550px] mx-auto lg:mx-0 text-center lg:text-left" style={{
      zIndex: 2
    }} data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.1
      }} transition={{
        duration: 0.8
      }} style={{
        opacity: 1
      }} data-id="element-15">
          <span className="inline-block text-gold text-[10px] md:text-xs font-extrabold tracking-[3px] uppercase mb-4" data-id="element-16">
            CIENCIA APLICADA
          </span>

          <h2 className="font-serif text-4xl md:text-5xl font-black mb-6 leading-tight" data-id="element-17">
            Intervención <br data-id="element-18" />
            <span className="text-gold" data-id="element-19">Bio-Digital</span>
          </h2>

          <p className="text-lg opacity-90 leading-relaxed mb-8" data-id="element-20">
            El Código 888 no es una simple meditación. Es una señal acústica
            diseñada para reprogramar tu{' '}
            <strong className="text-white font-bold" data-id="element-21">
              Sistema de Activación Reticular (SAR)
            </strong>
            , eliminando físicamente los surcos neuronales de la escasez.
          </p>

          <div className="flex flex-wrap gap-3 justify-center lg:justify-start mt-8" data-id="element-22">
            {['Neuro-Plasticidad', 'Ondas Theta', 'Frecuencias Solfeggio'].map((pill, index) => <motion.span key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.4,
            delay: 0.2 + index * 0.1
          }} className="border border-gold text-gold px-4 py-1.5 text-[10px] rounded-full uppercase font-extrabold tracking-wider" style={{
            opacity: 1
          }} data-id="element-23">
                  {pill}
                </motion.span>)}
          </div>
        </motion.div>
      </div>
    </section>;
}